<!-- <mat-toolbar class="navtoolbar" [class.ios]="utils.ios()" fxlayout="row" *ngIf="user && user?.activities && user?.activities.length > 0 && user?.color != null"> -->

<!-- <div class="addmenu-container animate__animated" (click)="toggleMenu()" [class.animate__slideInUp]="flags.showMenu" [class.animate__slideOutDown]="flags.showMenu==false" [class.hidden]="flags.showMenu==null">
<div class="addmenu" [style.background]="'linear-gradient(0deg, #111, '+user?.color+')'">
  <button mat-button (click)="showPostBox('planning')" routerLinkActive="active">
    <mat-icon>add</mat-icon>
  </button>
  <button mat-button (click)="showPostBox('getacoach')" routerLinkActive="active">
    <mat-icon>emoji_people</mat-icon>
  </button>
  <button mat-button (click)="showPostBox('coaching')" routerLinkActive="active">
    <mat-icon>group</mat-icon>
  </button>

</div>
</div> -->


@if (isNavVisible()) {
  <div #navtoolbar class="navtoolbar" [style.--user-color]="user?.color" [class.iosexploreBar]="utils.ios()" [class.android]="utils.android()" [class.sidenavOpen]="flags.sidenav" [class.nav-hidden]="isNavHidden">
    <div #messageDiv class="message" (click)="hideComm()" [routerLink]="commUrl"><div #messageText [innerHtml]="navComm"></div></div>
    @if (!url?.includes('settings') && !url?.includes('contact')) {
      <button mat-button routerLink="/explore" onclick="window.scrollTo(0,0)" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu();utils.sound('explore')">
        <mat-animated-icon start="explore" end="explore" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
      </button>
    }
    @if (url?.includes('settings') || url?.includes('contact')) {
      <button mat-button routerLink="/dashboard" onclick="window.scrollTo(0,0)" (click)="back();closeMenu();utils.sound('explore')">
        <mat-animated-icon start="arrow_back" end="arrow_back" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
      </button>
    }
    <button mat-button routerLink="/invites" onclick="window.scrollTo(0,0)" (click)="closeMenu();utils.sound()" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      @if (getPendingInvitesCount() > 0) {
        <div class="counter">{{ getPendingInvitesCount() }}</div>
      }
      <mat-animated-icon start="date_range" end="date_range" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
    </button>
    <div
      (click)="onLogoClick($event)"
      (dblclick)="onLogoDblClick($event)"
      (pointerdown)="onLogoPointerDown($event)"
      (pointerup)="onLogoPointerUp($event)"
      (pointerleave)="onLogoPointerLeave($event)"
      (contextmenu)="$event.preventDefault()"
      class="logoIcon animate__animated"
      [class.active]="url === '/dashboard' || url === '/dashboard/' || url === '/discover'">
      <img src="./assets/icons/icon-512x512.png" alt="Activity8">
    </div>
    <button mat-button routerLink="/messages" onclick="window.scrollTo(0,0)" (click)="closeMenu();utils.sound()" routerLinkActive="active">
      @if (user?.metrics?.unread_message > 0) {
        <div class="counter">{{ user?.metrics?.unread_message }}</div>
      }
      <mat-animated-icon start="message" end="message" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
    </button>
    @if (user?.metrics?.unread_interactions > 0) {
      <button mat-button routerLink="/recent" onclick="window.scrollTo(0,0)" class="last" (click)="closeMenu();utils.sound()" routerLinkActive="active">
        @if (user?.metrics?.unread_interactions > 0) {
          <div class="counter">{{ user?.metrics?.unread_interactions }}</div>
        }
        <mat-animated-icon start="favorite" end="favorite" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
      </button>
    }
    <!-- <button mat-button [routerLink]="'/' + user?.username" onclick="window.scrollTo(0,0)" class="last" (click)="closeMenu();utils.sound()" routerLinkActive="active" *ngIf="user?.metrics?.unread_interactions <= 0">
    <mat-animated-icon start="face" end="face" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
  </button>   -->
  @if (user?.metrics?.unread_interactions <= 0) {
    <button mat-button type="button" class="profile" (click)="onProfileClick($event)" [style.color]="user?.color" aria-label="Profile">
      <div class="border" [style.border-color]="user?.color">
        @if (getProfileBackground(user) == 'none') {
          <div class="noImage">
            @if (user?.first_name!='') {
              <span>{{user?.first_name}}</span>
            }
            @if (user?.first_name=='') {
              <span>:(</span>
            }
          </div>
        }
        <div class="image" [style.background-image]="flags.userImg">
          @if (user?.is_premium && !user?.is_verified) {
            <mat-icon matTooltip="Premium Member" class="premium" [style.color]="user?.color">star</mat-icon>
          }
          @if (!user?.is_premium && user?.is_verified) {
            <mat-icon matTooltip="Verified Member" class="premium" [style.color]="user?.color">fingerprint</mat-icon>
          }
          @if (user?.is_premium && user?.is_verified) {
            <mat-icon matTooltip="Verified & Premium" class="premium" [style.color]="user?.color">verified</mat-icon>
          }
          @if (user?.meta?.is_new && !user?.is_verified && !user?.is_premium) {
            <mat-icon class="premium" [style.color]="user?.color">fiber_new</mat-icon>
          }
          <!-- <div class="counter" [class.lightMode]="user?.color|isLight" [style.background-color]="user?.color">{{user?.activities?.length}}</div> -->
        </div>
      </div>
    </button>
  }
</div>
}

@if ((!user || !user.isAuthenticated) && url != '/' && !url?.includes('/join')  && !url?.includes('/login') && !url?.includes('/forgot') && !url?.includes('/about')) {
  <div class="navtoolbar navtoolbar-guest" [class.android]="utils.android()" [class.sidenavOpen]="flags.sidenav" [class.nav-hidden]="isNavHidden">
    @if (url == '/search' || url == '/search/posts' || url == '/search/activities' || url == '/search/members' || url?.includes('/trend')) {
      <button mat-button (click)="utils.toggleSidenav()">
        <mat-animated-icon start="menu" end="close" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
      </button>
    }
    <button mat-button class="login-btn-guest" (click)="clickLogin(); utils.sound()">
      <mat-animated-icon start="login" end="explore" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
    </button>
  </div>
}